<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-table #pt [value]="guestRefundReasons" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="guestRefundReasonId"
  selectionMode="single" [(selection)]="guestRefundReason" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="showPagination" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-2">
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined p-button-sm" style="padding: 0.5rem 0.75rem;"
            (click)="onOpenFormAdd()">+ Add Refund Amount</button>
        }
        @if (outlineNewButton) {
          <button pButton pRipple class="p-button p-button-sm" style="padding: 0.5rem 0.75rem;"
            (click)="onOpenFormAdd()">+ Add Refund Amount</button>
        }
        @if (outlineNewButton) {
          <h1 style="margin: 0; font-size: 1.25rem;">Refund Amounts</h1>
        }
        @if (!outlineNewButton) {
          <h6 style="margin: 0;">Refund Amounts</h6>
        }
      </div>
      @if (showFilter) {
        <button pButton pRipple class="p-button-text p-button-sm"
          style="font-size:80%;padding:0.4rem 0.5rem;"
          (click)="reloadPage()">Clear Filters</button>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    @if (recordTotal > 0) {
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
    @if (recordTotal < 1) {
      <tr>
        <td colspan="5" style="color:#888;font-style:italic;padding:0.5rem 0;">No refund amounts added yet.</td>
      </tr>
    }
    @if (showFilter) {
      <tr>
        <th><input style="width:100%;min-width:80px;" pInputText type="text"
          (input)="pt.filter($event.target.value, 'guestRefundVO.guestRefundLastName', 'in')"></th>
        <th><input style="width:100%;min-width:80px;" pInputText type="text"
          (input)="pt.filter($event.target.value, 'refundAmount', 'in')"></th>
        <th><input style="width:100%;min-width:80px;" pInputText type="text"
          (input)="pt.filter($event.target.value, 'reasonCode', 'in')"></th>
        <th><input style="width:100%;min-width:80px;" pInputText type="text"
          (input)="pt.filter($event.target.value, 'reasonDesc', 'in')"></th>
        <th></th>
      </tr>
    }
  </ng-template>

  <ng-template pTemplate="body" let-guestRefundReason>
    @if (!guestRefundId || guestRefundId == guestRefundReason.guestRefundId) {
      <tr [pSelectableRow]="guestRefundReason">
        <td>{{guestRefundLastName}}</td>
        <td><strong>${{guestRefundReason.refundAmount | number:'1.2-2'}}</strong></td>
        <td>{{getReasonCodeName(guestRefundReason)}}</td>
        <td>{{guestRefundReason.reasonDesc}}</td>
        <td>
          <a style="cursor:pointer;" (click)="onOpenFormEdit(guestRefundReason)">
            <i class="pi pi-pencil" style="color:blue;font-size:110%;padding-right:20px;" aria-hidden="true"></i>
          </a>
        </td>
      </tr>
    }
  </ng-template>
</p-table>
